<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
            <div class="modal-close grow" @click="closeModal">
            <i class="material-icons">close</i>
          </div>
          <div class="modal-title">Report an Issue</div>
          <div class="form-content">
            <div v-for="issue in reportReasons" :key="issue.reason" class="form-field">
              <v-checkbox
                v-model="selectedIssue"
                :value="issue.reason"
                class="reason-item"
              >
              <template v-slot:label>
                <span class="reason-label">{{ issue.message }}</span>
              </template>
            </v-checkbox>
            </div>
            <div class="field-error" v-if="errorText">{{ errorText }}</div>
            <transition name="slide-fade">
              <div v-if="needsConfirmation" class="field-error centered">
                Reporting this issue will cancel your assignment!
                <div v-if="assignment.is_flow_v2">
                The snaps you were given to read this book
                will be removed.
                </div>
              </div>
            </transition>
            <div  class="actions">
              <div class="action cancel-review" @click="submitReport" :class="{disabled:lockActionInProgress}">{{ actionButtonText }}</div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";
import Card from "../Assignment/Card";
import { mapState } from "vuex";

export default {
  name: "ReportReviewIssue",
  props: ["assignment", "reportReasons"],
  emits:["close"],
  components: { Card },
  data: function() {
    return {
      touchedButton: false,
      action: null,
      selectedIssue: null,
      lockActionInProgress: false,
      sucessMessage: null,
      needsConfirmation: false,
      reasonsForCancelAll: ['broken-link-download','broken-link-ku','broken-link-purchase','broken-link-review','price-mismatch','not-on-ku'],
      reasonsForMoreTime: ['more-time'],
    };
  },
  computed: {
    ...mapState({
      user: "user",
      allowedCountries: "allowedCountries"
    }),
    errorText() {
      if (!this.touchedButton) {
        return ''
      }
      if (!this.selectedIssue) {
        return "You must select a reason."
      }
    },
    actionButtonText() {
      if (!this.selectedIssue) {
        return "Cancel & Report"
      }
      if (this.needsConfirmation) {
        return "Confirm"
      }
      if (this.reasonsForMoreTime.includes(this.selectedIssue)) {
        return "Extend Assignment"
      }
      if (this.reasonsForCancelAll.includes(this.selectedIssue)) {
        return "Cancel & Report"
      }
      return "Cancel Assignment"
    }
  },
  created() {
  },
  methods: {
    async submitReport() {
      this.touchedButton = true;
      if (this.errorText) {
        return
      }
      if (this.actionButtonText.includes('Cancel') && !this.needsConfirmation) {
        this.needsConfirmation = true
        return;
      }
      this.lockActionInProgress = true;
      
      if (this.reasonsForCancelAll.includes(this.selectedIssue)) {
        switch (this.selectedIssue) {
          case 'broken-link-download':
            this.action = 'cancelAll_standard'
            break;
          case 'broken-link-purchase':
            this.action = 'cancelAll_vp'
            break;
          case 'price-mismatch':
            this.action = 'cancelAll_vp'
            break;
          case 'broken-link-ku':
            this.action = 'cancelAll_ku'
            break;
          case 'not-on-ku':
            this.action = 'cancelAll_ku'
            break;
          default:
            this.action = 'cancelAll'
        }
        this.sucessMessage = "Your assignment has been cancelled successfully and your issue reported."
      } else if (this.reasonsForMoreTime.includes(this.selectedIssue)) {
        this.action = 'moreTime'
        this.sucessMessage = "We've given you a few more days to complete your assignment!"
      } else {
        this.action = false
        this.sucessMessage = "Your assignment has been cancelled successfully."
      }

      if (this.action) {
        console.log("reporting assignment");
        await Back.reportAssignmentIssue({
        assignment_id: this.assignment.id,
        action: this.action,
        })
        .then (response => {
          this.lockActionInProgress = false;
          if (!response) {
            this.$toasted.show(
              "Oops! Something went wrong. Please try again later.",
              {
                icon: "error",
                position: "bottom-center",
                duration: 3000
              }
            );
          } else if (response.message) {
            this.$toasted.show(
              response.message,
              {
                icon: "error",
                position: "bottom-center",
                duration: 3000
              }
            );
          } else {
            this.$toasted.show(this.sucessMessage, 
            {
              icon: "check_circle",
              position: "bottom-center",
              duration: 3000
            });
            Bus.$emit("UserChanged", null);
            setTimeout(() => {
              this.$router.push("/reader");
            }, 500);
          }
        })
      } else {
      console.log("cancelling assignment");
        await Back.cancelAssignment(this.assignment)
        .then (response => {
          this.lockActionInProgress = false;
          if (!response) {
            this.$toasted.show(
              "Oops! Something went wrong. Please try again later.",
              {
                icon: "error",
                position: "bottom-center",
                duration: 3000
              }
            );
          } else {
            this.$toasted.show(this.sucessMessage, 
            {
              icon: "check_circle",
              position: "bottom-center",
              duration: 3000
            });
            Bus.$emit("UserChanged", null);
            setTimeout(() => {
              this.$router.push("/reader");
            }, 500);
          }
        })
      }
    },
    closeModal() {
      this.$emit('close')
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  padding: 0.5em;
  padding-left: 30px;
  font-size: 21pt;
  font-weight: 500;
  color: #111;
  text-align: center;
}
.modal-instructions {
  font-size: 12pt;
  color: #111;
  text-align: center;
}
.modal-limit-instructions {
  padding: 60px 120px;
  font-size: 13.5pt;
  color: #111;
  text-align: center;
}
.modal-close {
  font-size: 15pt;
  margin-right: 6px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}

.find-book {
  background: #fff;
  box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.14);
  font-family: $font-family;
}

.form-content {
  padding: 20px;
}

.input-label {
  float: left;
  width: 170px;
}
.input-box {
  float: left;
  width: 550px;
}

.input-label {
  padding: 20px 12px;
  font-size: 14pt;
  line-height: 1.4em;
}
.field-instructions {
  text-align: center;
  padding: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: #777;
}
.form-field {
  margin-left: 9.5em;
}
.field-error {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: rgb(235, 96, 96);
}
.reason-item {
  padding: 0px !important;
  margin: 0px !important;
}
.reason-label {
  font-size: 13pt;
  color: black !important;
}
.disabled {
  color: #dbdbdb !important;
  pointer-events: none;
}
.actions {
  display: flex;
  justify-content: center;
  padding: 4px;
}

.cancel-review {
  background: #ede7f6;
  color: #9575cd;
}
// .action-selection {
//   flex-grow: 0;
//   text-align: center;
// }
// .action-refresh {
//   flex-grow: 0;
//   flex-basis: 260px;
//   margin-left: auto;
//   padding-right: 48px;
//   text-align: center;
// }
// .action-refresh-item {
//   float: right;
//   width: 120px;
//   text-align: center;
//   border: 0px solid #f3f3f3;
//   border-radius: 8px;
//   margin: 0 8px;
//   padding: 0.4em 0.75em;
//   font-size: 12pt;
//   color: #777;
//   font-weight: 600;
//   letter-spacing: 1px;
//   text-transform: uppercase;
// }
// .action-refresh-item:hover {
//   cursor: pointer;
//   color: #999;
// }
// .action {
//   background: #ede7f6;
//   color: #9575cd;
// }
// .actions {
//   text-align: center;
//   padding-top: 20px;
// }
.centered {
  font-size: 14pt;
  padding-top: 1em;
  text-align: center;
}

.confirm-text {
  padding: 0.75em 0 0 0;
  font-size: 11.5pt;
  color: #333;
  text-align: center;
}
.points-text {
  color: darken(#ffa000, 6%);
  font-weight: 700;
}
.book-title {
  color: $color-blue;
  font-weight: 700;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  z-index: 100000;
}

.modal-container {
  z-index: 999999;
  width: 800px;
  margin: 0px auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.19);
  transition: all 0.3s ease;
  font-family: "Source Sans Pro";
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

@media (max-width: 1024px) {
  // .modal-mask {
  //   position: absolute !important;
  // }
  .modal-container {
    height: auto;
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
  }

  .modal-title {
    text-align: left;
    font-size: 19pt;
    padding-top: 1px;
    padding-left: 18px;
    padding-right: 0;
  }

  .modal-close {
    float: right !important;
    position: initial !important;
    margin-right: 12px !important;
  }

  .modal-limit-instructions {
    padding: 8px 16px 16px 16px;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translate(100%, 0%);
  opacity: 0;
}
</style>


